/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAuth, useStore } from '@/containers'
import { CouponArrowDown, IconCloseWhiteCircle } from '@/styles/Icon'
import type { Region, Store } from '@/types'
import { api } from '@/utils'
import { getTranslate } from '@/utils/api-interceptors'
import { convertQueryParam } from '@/utils/next-util'
import { Dialog, Listbox, Transition } from '@headlessui/react'
import { title } from 'process'
import { Fragment, useEffect, useRef, useState } from 'react'
import { LoadingIndicator } from '../LoadingIndicator'

const ModalBranchExhibition = ({
  isOpen,
  setIsOpen,
  productId
}: {
  isOpen: boolean
  setIsOpen: (data: boolean) => void
  productId: string | number
}) => {
  const { globalLoading, regionList } = useAuth()
  const [listBranch, setListBranch] = useState<Store[] | null>(null)
  const { currentRegion, provinces } = useStore()
  const [selectedRegion, setSelectedRegion] = useState<Region>()
  const regionDefault = regionList.find(e => e.code == currentRegion)
  const queryParam = {
    productId: productId,
    regionCode: selectedRegion?.code
  }
  const params = convertQueryParam(queryParam)
  const getListBranch = async () => {
    const res = await api(`api/store-inventory?${params}`, {
      method: 'GET',
      baseURL: process.env.NEXT_PUBLIC_ECOMMERCE_API_URL
    })

    if (res && !(res instanceof Error)) {
      setListBranch(res?.data)
      return
    }
  }
  useEffect(() => {
    if (productId) {
      getListBranch()
    }
  }, [productId, isOpen, selectedRegion])
  useEffect(() => {
    if (regionDefault) setSelectedRegion(regionDefault)
  }, [regionDefault])

  const completeButtonRef = useRef(null)
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        initialFocus={completeButtonRef}
        as='div'
        className={`relative z-[9999]`}
        onClose={() => setIsOpen(false)}
      >
        <Transition.Child
          as={Fragment}
          enter='ease-in-out duration-500'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in-out duration-500'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bottom-0 left-0 bg-black-150 transition-opacity' />
        </Transition.Child>
        <div
          className={` pointer-events-none fixed bottom-0 left-[50%] z-50 flex h-full max-h-[60vh] w-full max-w-[440px] translate-x-[-50%] overflow-hidden rounded-tl-sm rounded-tr-sm `}
        >
          <Transition.Child
            as={Fragment}
            enter='transform transition ease-in-out duration-500'
            enterFrom='translate-y-[70%]'
            enterTo='translate-y-[0%]'
            leave='transform transition ease-in-out duration-500'
            leaveFrom='translate-y-[0%]'
            leaveTo='translate-y-[100%]'
          >
            <Dialog.Panel className='pointer-events-auto h-full w-full max-w-[440px] shadow-modal'>
              <div className={`block w-full transform overflow-hidden bg-white pb-6 align-middle shadow-modal`}>
                <div className={`relative h-28 w-full bg-red px-3 pb-2 pt-4 text-white`}>
                  <div className={`headerModal`}>
                    {title != '' && (
                      <Dialog.Title as='h2' className={`text-titleSection`}>
                        Xem siêu thị có hàng trưng bày
                      </Dialog.Title>
                    )}
                    <button onClick={() => setIsOpen(false)} className={`absolute right-3 top-4 z-10 cursor-pointer`}>
                      <IconCloseWhiteCircle />
                    </button>
                  </div>
                  <Listbox
                    value={selectedRegion}
                    onChange={setSelectedRegion}
                    as={'div'}
                    className='relative mt-4 w-full'
                  >
                    <Listbox.Button className={`relative h-10 w-full rounded-lg bg-white px-4 text-left text-dark-400`}>
                      {selectedRegion?.name}
                      <span className='absolute right-4 top-1/2 -translate-y-1/2'>
                        <CouponArrowDown />
                      </span>
                    </Listbox.Button>
                    <Listbox.Options
                      as='div'
                      className='absolute mt-1.5 max-h-60 w-full cursor-pointer overflow-auto rounded-md bg-white px-2 py-3 text-base text-dark-400 shadow-lg focus:outline-none'
                    >
                      {regionList.map(region => (
                        <Listbox.Option
                          key={region._id}
                          value={region}
                          as='div'
                          className={({ selected, active }) =>
                            `relative flex h-10 w-full items-center justify-center bg-white text-center ${
                              selected || active ? 'border-blue-800' : 'border-neutral-200'
                            } hover:border-blue hover:text-blue`
                          }
                        >
                          {region.name}
                        </Listbox.Option>
                      ))}
                    </Listbox.Options>
                  </Listbox>
                </div>
                <div
                  className={`scrollBarCS mr-1.5 h-full max-h-[calc(60vh-112px)] min-h-[calc(60vh-112px)] max-w-[calc(100%-8px)] pl-2 pr-1`}
                >
                  <div className='listLocation scrollBarCS flex h-full min-h-[calc(55svh-20px)] flex-row flex-wrap content-start justify-start gap-y-1 overflow-y-auto border-white-500 pb-8 pt-4 '>
                    <span className='mb-2 text-base'>
                      Có <strong>{listBranch && listBranch?.length}</strong> siêu thị có hàng trưng bày tại{' '}
                      <strong>{selectedRegion?.name}</strong>
                    </span>
                    {globalLoading ? (
                      <LoadingIndicator />
                    ) : (
                      listBranch &&
                      listBranch?.map((item, index) => (
                        <div
                          key={index}
                          className={`block min-h-[58px] w-full overflow-hidden rounded bg-white-500 px-3 py-2 outline-none `}
                        >
                          <div className='flex flex-wrap items-start'>
                            <div className='flex max-w-[calc(100%-30px)] flex-[calc(100%-30px)] flex-row flex-wrap items-start justify-start text-left'>
                              <p className={'mb-1 block w-full text-base font-bold'}>
                                {getTranslate(item.name)} -{' '}
                                {provinces &&
                                  provinces
                                    ?.find(e => e?.code == item?.provinceCode)
                                    ?.name?.replace('Tỉnh ', '')
                                    .replace('Thành phố ', '')}
                              </p>
                              <p className='block w-full text-sm text-dark-400'>Điện thoại: {item.phoneNumber}</p>
                              <p className='block w-full text-sm text-dark-400'>Địa chỉ: {item.fullAddress}</p>
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  )
}

export default ModalBranchExhibition
